module.exports = __webpack_public_path__ + "img/30_20.a46db0b9.png";